import React, { Component } from 'react'
import { connect } from "react-redux";
import {
    Input,
} from 'reactstrap';
import { downloadSampleData } from '../../actions';
import { withRouter } from "react-router-dom";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './search.css'

class Search extends Component {    
    searchSample = () => {
        if(["/samples/addsamples/", "/samples/addsamples"].includes(this.props.location.pathname))
            this.props.downloadSampleData({search: this.props.sampleSearch})
        else
            this.props.history.push("/samples/addsamples/")
    }
    
    handleInputChange = async (event) => {
        await this.props.setSearch(event.target.value)
        this.searchSample()
    }

    resetSample = () => {
        this.props.setSearch('')
        this.props.downloadSampleData()
    }

    render() {
        return (
            <div>
                {window.innerWidth>1000 && !localStorage.getItem("guest")&& <div className="global-search" data-tut="reactour__search">
                    <div className='serach-vertical-line'/>
                    <Input className="search-input" name="searchSample" id="searchSample"
                        placeholder="   Search a EF barcode"
                        value={this.props.sampleSearch}
                        onChange={this.handleInputChange}
                        autoComplete="off"
                    />
                    {this.props.sampleSearch ?
                        <FontAwesomeIcon className="global-close-icon" icon={faTimes} size="s" onClick={() => { this.resetSample() }} />
                        : null}
                </div> }
            </div>
        )
    }
}

const mapStateToProps = state => {

    return {
        searchResult: state.results_data.searchResult,
        searchLocation: state.location_data.searchLocation
    }
}

const ShowTheLocationWithRouter = withRouter(Search);
export default connect(
    mapStateToProps,
    {
        downloadSampleData,
    }
)(ShowTheLocationWithRouter)